import _createForOfIteratorHelper from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import defaultSetting from '@/settings.js';

import { ref, onMounted } from 'vue';
// 创建粒子类
var MAX_LEN = 200;
export default /*@__PURE__*/_defineComponent({
  __name: 'Particle',
  setup: function setup(__props) {
    var Particle = /*#__PURE__*/function () {
      function Particle(x, y, radius, color, speedX, speedY) {
        _classCallCheck(this, Particle);
        _defineProperty(this, "x", void 0);
        _defineProperty(this, "y", void 0);
        _defineProperty(this, "radius", void 0);
        _defineProperty(this, "color", void 0);
        _defineProperty(this, "speedX", void 0);
        _defineProperty(this, "speedY", void 0);
        this.x = x;
        this.y = y;
        this.radius = radius;
        this.color = color;
        this.speedX = speedX;
        this.speedY = speedY;
      }
      return _createClass(Particle, [{
        key: "draw",
        value: function draw(ctx) {
          ctx.beginPath();
          ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
          ctx.closePath();
          ctx.fillStyle = this.color;
          ctx.fill();
        }
      }, {
        key: "update",
        value: function update(particles) {
          this.x += this.speedX;
          this.y += this.speedY;
          // 碰撞检测
          var _iterator = _createForOfIteratorHelper(particles),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var particle = _step.value;
              if (particle !== this) {
                var distance = Math.sqrt(Math.pow(this.x - particle.x, 2) + Math.pow(this.y - particle.y, 2));
                if (distance < this.radius + particle.radius) {
                  // 碰撞发生，交换速度
                  var tempSpeedX = this.speedX;
                  var tempSpeedY = this.speedY;
                  this.speedX = particle.speedX;
                  this.speedY = particle.speedY;
                  particle.speedX = tempSpeedX;
                  particle.speedY = tempSpeedY;
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }]);
    }();
    var canvas = ref(null);
    var particles = [];
    var colors = ref(['#3261c8', '#627dc2']);
    // 生成随机整数
    function randomIntFromRange(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    }
    // 生成随机颜色
    function randomColor() {
      return colors.value[Math.floor(Math.random() * colors.value.length)];
    }
    // 限制粒子数量在视图内
    function limitParticlesInView(maxParticles) {
      var particlesInView = particles.filter(function (particle) {
        return particle.x > 0 && particle.x < canvas.value.width && particle.y > 0 && particle.y < canvas.value.height;
      });
      if (particlesInView.length > maxParticles) {
        // 超过限制时删除多余的粒子
        particles.splice(maxParticles, particlesInView.length - maxParticles);
      }
    }
    // 初始化粒子数组
    function init() {
      for (var i = 0; i < 50; i++) {
        var radius = randomIntFromRange(1, 5);
        var x = randomIntFromRange(radius, window.innerWidth - radius);
        var y = randomIntFromRange(radius, window.innerHeight - radius);
        var color = randomColor();
        var speedX = (Math.random() - 0.5) * 2; // 随机速度在[-1, 1]之间
        var speedY = (Math.random() - 0.5) * 2;
        particles.push(new Particle(x, y, radius, color, speedX, speedY));
      }
    }
    // 动画循环
    function animate() {
      var _canvas$value;
      requestAnimationFrame(animate);
      var ctx = (_canvas$value = canvas.value) === null || _canvas$value === void 0 ? void 0 : _canvas$value.getContext('2d');
      ctx === null || ctx === void 0 || ctx.clearRect(0, 0, canvas.value.width, canvas.value.height);
      particles.forEach(function (particle) {
        particle.update(particles);
        particle.draw(ctx);
      });
      limitParticlesInView(MAX_LEN);
    }
    onMounted(function () {
      if (canvas.value && defaultSetting.enableLoginParticle) {
        canvas.value.width = window.innerWidth;
        canvas.value.height = window.innerHeight;
        init();
        animate();
        window.addEventListener('resize', function () {
          canvas.value.width = window.innerWidth;
          canvas.value.height = window.innerHeight;
          init(); // 调整窗口大小时重新初始化粒子数组
        });
        canvas.value.addEventListener('click', function (event) {
          for (var i = 0; i < 10; i++) {
            var x = void 0,
              y = void 0;
            var overlap = false;
            var radius = randomIntFromRange(3, 6);
            do {
              overlap = false;
              x = event.clientX + (Math.random() - 0.5) * 100; // 在点击位置稍微偏移一些
              y = event.clientY + (Math.random() - 0.5) * 100; // 在点击位置稍微偏移一些
              for (var _i = 0, _particles = particles; _i < _particles.length; _i++) {
                var particle = _particles[_i];
                var distance = Math.sqrt(Math.pow(x - particle.x, 2) + Math.pow(y - particle.y, 2));
                if (distance < 2 * radius) {
                  overlap = true;
                  break;
                }
              }
            } while (overlap);
            var color = randomColor();
            var speedX = (Math.random() - 0.5) * 4; // 随机速度在[-2, 2]之间
            var speedY = (Math.random() - 0.5) * 4;
            particles.push(new Particle(x, y, radius, color, speedX, speedY));
          }
        });
      }
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("canvas", {
        id: "particleCanvas",
        ref_key: "canvas",
        ref: canvas
      }, null, 512);
    };
  }
});